/* tslint:disable */
/* eslint-disable */
/**
 * acomo API docs
 * acomoのAPI仕様書です。
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SlackConnectivityResponse
 */
export interface SlackConnectivityResponse {
    /**
     * Slackの疎通に成功したかどうか
     * 成功時はtrue, 失敗時はfalse
     * @type {boolean}
     * @memberof SlackConnectivityResponse
     */
    isSuccess: boolean;
    /**
     * 処理結果のメッセージ
     * @type {string}
     * @memberof SlackConnectivityResponse
     */
    message: string;
    /**
     * SlackチャンネルID
     * Slack側で管理されるチャンネルのIDそのもの。
     * @type {string}
     * @memberof SlackConnectivityResponse
     */
    channelId: string;
    /**
     * チャンネル名
     * @type {string}
     * @memberof SlackConnectivityResponse
     */
    channelName: string;
    /**
     * エラーコード
     * @type {string}
     * @memberof SlackConnectivityResponse
     */
    errorCode: string;
}

/**
 * Check if a given object implements the SlackConnectivityResponse interface.
 */
export function instanceOfSlackConnectivityResponse(value: object): value is SlackConnectivityResponse {
    if (!('isSuccess' in value) || value['isSuccess'] === undefined) return false;
    if (!('message' in value) || value['message'] === undefined) return false;
    if (!('channelId' in value) || value['channelId'] === undefined) return false;
    if (!('channelName' in value) || value['channelName'] === undefined) return false;
    if (!('errorCode' in value) || value['errorCode'] === undefined) return false;
    return true;
}

export function SlackConnectivityResponseFromJSON(json: any): SlackConnectivityResponse {
    return SlackConnectivityResponseFromJSONTyped(json, false);
}

export function SlackConnectivityResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SlackConnectivityResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'isSuccess': json['isSuccess'],
        'message': json['message'],
        'channelId': json['channelId'],
        'channelName': json['channelName'],
        'errorCode': json['errorCode'],
    };
}

export function SlackConnectivityResponseToJSON(json: any): SlackConnectivityResponse {
    return SlackConnectivityResponseToJSONTyped(json, false);
}

export function SlackConnectivityResponseToJSONTyped(value?: SlackConnectivityResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'isSuccess': value['isSuccess'],
        'message': value['message'],
        'channelId': value['channelId'],
        'channelName': value['channelName'],
        'errorCode': value['errorCode'],
    };
}

